<template>
    <tr>
        <td>
            <button v-if="checkIfEditEnabled" class="button is-primary" @click="updateItem">
                <i class="fas fa-save"></i>
            </button>
            <button  v-if="!checkIfEditEnabled" class="button" @click="editItem">
                <i class="fas fa-edit"></i>
            </button>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled" v-html="item.name "></span>
            <input class="input" v-if="checkIfEditEnabled" v-model="name"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.remarks }}</span>
            <input class="input" v-if="checkIfEditEnabled" v-model="remarks"/>
        </td>
        <td>
            <span v-if="!checkIfEditEnabled">{{ item.amount }}</span>
            <input class="input" v-if="checkIfEditEnabled" v-model="amount"/>
        </td>
        <td>
            <button class="button is-danger" v-if="index > 0" @click="deleteItem">
                <i class="fas fa-trash"></i>
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        props:['item', 'index'],
        computed: {
            checkIfEditEnabled() {
                return this.$store.getters.getCustomInvoiceSelectedCostItem.id === this.item.id
            },
            name: {
                get() {
                   return this.$store.getters.getCustomInvoiceSelectedCostItem.name
                },
                set(value) {
                   this.$store.dispatch('changeCustomInvoiceSelectedCostItemFieldValue', { field: 'name', value: value})
                }
            },
            remarks: {
                get() {
                    return this.$store.getters.getCustomInvoiceSelectedCostItem.remarks
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceSelectedCostItemFieldValue', { field: 'remarks', value: value})
                }
            },
            amount: {
                get() {
                    return this.$store.getters.getCustomInvoiceSelectedCostItem.amount
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceSelectedCostItemFieldValue', { field: 'amount', value: value})
                }
            }
        },
        methods: {
            editItem() {
                this.$store.dispatch('changeCustomInvoiceSelectedCostItem', this.item)
                this.$store.dispatch('changeCustomInvoiceSelectedCostItemIndex', this.index)
            },
            updateItem() {
                this.$store.dispatch('updateCustomInvoiceCostItem')
                this.$store.dispatch('changeCustomInvoiceTotalCostAmount')
                this.$store.dispatch('calculateCustomInvoice')
            },
            deleteItem() {
                this.$store.dispatch('deleteCustomInvoiceCostItem', this.item)
                this.$store.dispatch('changeCustomInvoiceTotalCostAmount')
                this.$store.dispatch('calculateCustomInvoice')
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceCostsTableRow.vue